import request from "@/utils/login";
import qs from "qs";

export async function checkPhoneExist(phone) {
  return request.get("/api/v3/account/phone/exist", { params: { phone } });
}

export async function getPhoneVcode(phone) {
  return request({
    url: `/api/v3/account/phone/sendSms?phone=${phone}`,
    method: "post",
  });
}

export function mailLogin(params) {
  // url: "api/v3/account/web/login",
  return request({
    url: "/api/v3/account/web/login_hybrid_center",
    method: "post",
    data: qs.stringify(params),
  });
}

// export function login(account, password) {
//   return request({
//     url: "api/v3/account/sys/login",
//     method: "post",
//     data: qs.stringify({
//       account,
//       password,
//     }),
//   });
// }

// export function checkPasswordSet(accessToken) {
//   return request({
//     url: `/api/v3/account/check_password_set`,
//     method: "get",
//     headers: {
//       Authorization: accessToken,
//     },
//   });
// }

export function setPassword(userId, password, accessToken) {
  return request({
    url: `/api/v3/account/set_password`,
    method: "post",
    data: qs.stringify({ userId, password }),
    headers: {
      Authorization: accessToken,
    },
  });
}

// 微信授权登录
export function authLogin(d) {
  return request({
    url: "api/v3/account/login_auth",
    // url: "api/v3/account/sys/auth",
    method: "post",
    data: qs.stringify(d),
  });
}

// 获取微信授权的access token
export function getWechatAccessToken(code, state) {
  return request({
    // url: "api/v3/account/wechat/access_token",
    url: "api/v3/account/wechat/userinfo",
    method: "get",
    params: { code, state },
  });
}

// 刷新access token
export function refreshToken(refreshToken) {
  return request({
    url: `api/v3/account/refresh_token`,
    method: "get",
    params: { refresh_token: refreshToken },
  });
}

// 获取用户信息
export function getInfo(id) {
  return request({
    url: `api/v3/users/${id}/show`,
    method: "get",
    params: { u: id },
  });
}

// 获取用户信息
export function getRoles(id) {
  return request({
    url: `adm/server/sys/roles`,
    method: "get",
    params: { u: id },
  });
}

// 获取用户信息
export function getUserinfo(accessToken) {
  return request({
    url: `api/v3/account/get_user_info`,
    method: "get",
    headers: {
      Authorization: accessToken,
    },
  });
}

export function verifyToken(accessToken) {
  return request({
    url: `api/v3/account/token/verify`,
    method: "get",
    headers: {
      Authorization: accessToken,
    },
  });
}

// 当前登录账号的关联账号
export function getAccountList(accessToken) {
  return request({
    url: `/api/v3/teacher_hybrid/account_list`,
    method: "get",
    headers: {
      Authorization: accessToken,
    },
  });
}

// 获取子账号用户身份信息
export function getUserIdentify(accessToken, userId) {
  return request({
    url: `/api/v3/teacher_hybrid/${userId}/user_identify`,
    method: "get",
    headers: {
      Authorization: accessToken,
    },
  });
}

export function getUserModule(userId, accessToken) {
  return request({
    url: `/api/v3/column_hybrid/douyin/${userId}/user_module_list`,
    method: "get",
    headers: {
      Authorization: accessToken,
    },
  });
}
